import { gql } from '@apollo/client';

const AI_LIST_PROMPT_REPORTS_QUERY = gql`
    query ListPromptReports($promptId: UUID!) {
        promptReports(promptId: $promptId) {
            id
            companyId
            promptId
            csvObjectKey
            graphObjectKey
            rawData
            numRows
            csvSignedUrl
            createdAt
            graphSignedUrl
        }
    }
`;

export default AI_LIST_PROMPT_REPORTS_QUERY;
 